import { Injectable } from '@angular/core';
import {InfoSectionCategory} from "../interfaces/info-section-category";
import {GetAllInfoSectionCategories_infoSectionCategories} from "../queries/__generated__/GetAllInfoSectionCategories";
import {InfoSectionEntry} from "../interfaces/info-section-entry";
import {InfoSectionSubCategory} from "../interfaces/info-section-sub-category";

@Injectable({
  providedIn: 'root'
})
export class InfoSectionService {

  constructor() { }

  mapRawInfoSectionCategory(rawInfoSectionCategory: GetAllInfoSectionCategories_infoSectionCategories): InfoSectionCategory {
    let parsedInfoSectionCategory: InfoSectionCategory = {
      id: rawInfoSectionCategory.id ?? "",
      urlText: rawInfoSectionCategory.urlText ?? "",
      heading: rawInfoSectionCategory.heading ?? "",
      link: rawInfoSectionCategory.link ?? "",
      description: rawInfoSectionCategory.description ?? "",
      subCategories: [],
      position: rawInfoSectionCategory.position ?? -1,
      type: {
        id: rawInfoSectionCategory.type.id
      }
    };

    rawInfoSectionCategory.subCategories?.forEach(subCategory => {
      let parsedSubCategory: {id: string, urlText: string, heading: string, description: string, position: number, entries: InfoSectionEntry[]} = {
        id: subCategory.id ?? "",
        urlText: subCategory.urlText ?? "",
        heading: subCategory.heading ?? "",
        description: subCategory.description ?? "",
        position: subCategory.position ?? -1,
        entries: new Array(0)
      };

      subCategory.entries?.forEach(entry => {
        parsedSubCategory.entries.push({
          id: entry.id ?? "",
          heading: entry.heading ?? "",
          description: entry.description ?? "",
          position: entry.position ?? -1,
          url: entry.url ?? "",
        })
      });

      parsedInfoSectionCategory.subCategories.push(parsedSubCategory);
    })

    return parsedInfoSectionCategory;
  }

  getInfoSectionCategoriesByTypeId(allIfoSectionCategories: InfoSectionCategory[], type: string): InfoSectionCategory[] {
    let filteredInfoSectionCategories = allIfoSectionCategories.filter(category => {
      return category.type.id === type;
    });

    filteredInfoSectionCategories.sort((a,b) => a.position - b.position);

    return filteredInfoSectionCategories;

  }

  getInfoSectionSubCategoriesByParentId(allIfoSectionCategories: InfoSectionCategory[], categoryId: string): InfoSectionSubCategory[] {
    let filteredInfoSectionSubCategories: InfoSectionSubCategory[] = [];
    allIfoSectionCategories.forEach(category => {
      if(category.id === categoryId) {
        filteredInfoSectionSubCategories.push(...category.subCategories);
      }
    });
    return filteredInfoSectionSubCategories;
  }

  getInfoSectionById(allIfoSectionCategories: InfoSectionCategory[], categoryId: string): InfoSectionCategory | undefined {
    let foundCategory = undefined;
    allIfoSectionCategories.forEach((category) => {
      if(category.urlText === categoryId) {
        foundCategory = category;
      }
    });

    return foundCategory;
  }

}
